import mutations from './mutations'
import * as actions from './actions'

const state = {
  single_todo: {
    title: '',
    description: '',
    completed: false
  },
  todos: [
  ],
  selected_notification : {},
  selected_notification_admin : {},
  notification_list : []
}

export default {
  state,
  mutations,
  actions
}


// WEBPACK FOOTER //
// ./src/store/modules/notifications/index.js